import * as React from 'react';

import { useScreenType } from '@gitbook/spine-react';

import { ModalFrame } from '../Modals';
import { useCurrentPortal } from '../Portal';
import { PopoverDesktop } from './PopoverDesktop';
import type { PopoverProps, PopoverRef } from './types';

/**
 * Popover to show actions or more infos on an element.
 */
export const Popover = React.forwardRef(function PopoverWithRef(
    props: PopoverProps,
    ref: React.Ref<PopoverRef>
): React.ReactElement | null {
    const { isMobile } = useScreenType();
    const portal = useCurrentPortal();

    if (isMobile) {
        if (props.kind === 'tooltip') {
            return null;
        }

        return (
            <ModalFrame onClose={portal.close} size={props.kind === 'menu' ? 'small' : 'medium'}>
                {props.children}
            </ModalFrame>
        );
    }

    return <PopoverDesktop ref={ref} {...props} />;
});

Popover.defaultProps = {
    kind: 'default',
};
